import { render, staticRenderFns } from "./plan-detail.vue?vue&type=template&id=b16f3e8c&scoped=true"
import script from "./plan-detail.vue?vue&type=script&lang=js"
export * from "./plan-detail.vue?vue&type=script&lang=js"
import style0 from "./plan-detail.vue?vue&type=style&index=0&id=b16f3e8c&prod&lang=less&scoped=true"
import style1 from "./plan-detail.vue?vue&type=style&index=1&id=b16f3e8c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16f3e8c",
  null
  
)

export default component.exports